import React from "react";
import { Text } from "react-konva";

const RecordIcon = (props) => {
  const { x, y, entityCategory } = props;

  let recordIcon = "\uf0c0";
  if (entityCategory === "Natural Person") {
    recordIcon = "\uf007";
  } else if (entityCategory === "Legal Person") {
    recordIcon = "\uf19c";
  }
  return (
    <Text
      x={x}
      y={y}
      fontSize={13}
      fontFamily="Font Awesome 5 Pro"
      fontStyle="normal 900"
      text={recordIcon}
      fill="black"
    />
  )
}

export default RecordIcon;